'use client';

import { Icon } from '@chemist4u/newt-components';
import { brand } from '@lib/config/brand';
import LocalizedClientLink from '@modules/common/components/localized-client-link';

import Image from 'next/image';

type PanelHeaderProps = {
  onClose: () => void;
};

const PanelHeader = ({ onClose }: PanelHeaderProps) => (
  <div className="flex items-center justify-between px-3 py-2 bg-brand-primary-700 shrink-0">
    <LocalizedClientLink
      href="/"
      onClick={onClose}
      aria-label={`${brand.name} home`}
    >
      <Image
        src={brand.logo}
        alt={brand.name}
        width={120}
        height={36}
        className="h-9 w-auto"
        preload
      />
    </LocalizedClientLink>
    <button
      type="button"
      onClick={onClose}
      data-testid="close-menu-button"
      className="p-2.5 text-white cursor-pointer hover:text-fg-accent-inverse-soft focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-white rounded"
      aria-label="Close menu"
    >
      <Icon name="xClose" size="24" aria-hidden="true" />
    </button>
  </div>
);

export default PanelHeader;
